<template>
  <vs-popup :title="title" :active.sync="popupActive" id="pdf-reader">
    <vs-tabs v-if="popupActive">
      <vs-tab :label="file.name" v-for="(file, index) in files" :key="index">
        <div class="tab-text" v-if="file.source">
          <iframe
            :src="file.source"
            class="w-full show-pdf"
            :style="{ height: '70vh' }"
          ></iframe>
        </div>
      </vs-tab>
    </vs-tabs>
  </vs-popup>
</template>

<script>
export default {
  computed: {
    title() {
      return this.$store.state.pdfReader.title
    },
    files() {
      return  this.$store.state.pdfReader.files
    },
    active () {
      return this.$store.state.pdfReader.active
    },
  },
  data() {
    return {
      popupActive: false,
    }
  },
  watch:{
    active(val){
      this.popupActive = this.active
    },
    popupActive(val){
      if(!val){
        this.$store.dispatch('togglePdfReader', {
          active: false,
          files: [],
          title:''
        })
      }
    }
  }
}
</script>

<style>
/* 1366 x 768 */
#pdf-reader>div.vs-popup {
  width: calc(100% - 30px) !important;
}


</style>
